// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__4uSrj","right":"styles_right__3itmG"};